import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../../../Button';

export function ModalFooter(props) {
  const onClick = (event) => {
    event.stopPropagation();
    props.onClick();
  };

  return <div className={props.className}>
    <Button onClick={onClick} disabled={props.disabled}>
      {props.text}
    </Button>
  </div>
}

ModalFooter.propTypes = {
  /**
   * ClassName to set on MoalFooterBlock
   */
  className: PropTypes.string,
  /**
   * Text to display on the Modal Footer button
   */
  text: PropTypes.string,
  /**
   * Fucntion to invoke on button click
   */
  onClick: PropTypes.func,
  /**
   * Boolean to set if button is disabled
   */
  disabled: PropTypes.bool,
};

ModalFooter.defaultProps = {
  disabled: false
};
